import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getEffectiveCharm, getNoCharmInfoObject } from '../index';

/**
 * This function returns event charm ID when the user sets it and
 * calendar folder charm ID when the user does not
 */
export default function getPPFCharmIdFromEvent(event: CalendarEvent): number {
    if (event) {
        let parentCharmId: number = getEffectiveCharm(event.ParentFolderId).IconId;
        let eventCharmId: number = event.CharmId;

        if (eventCharmId != parentCharmId && eventCharmId != getNoCharmInfoObject().IconId) {
            return eventCharmId;
        } else {
            return parentCharmId;
        }
    } else {
        return null;
    }
}
